// extracted by mini-css-extract-plugin
export var references = "styles-module--references--d4d18";
export var referencesList = "styles-module--references-list--ea023";